import Closing from "./Closing"
import Cta from "./Cta"
import Hero from "./Hero"
import Pain from "./Pain"
import Staircase from "./Staircase"

/**
 * Marketing homepage (issue #87). Section order follows the PromptJuggler /
 * Holigral model: hero → bare pain line → details staircase → method/closing
 * → CTA. Nav and Footer come from the public route layout.
 */
export default function Homepage() {
  return (
    <>
      <Hero />
      <Pain />
      <Staircase />
      <Closing />
      <Cta />
    </>
  )
}
